var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallllery/24px/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M3.54862 3.4043C3.75435 3.19857 4.0879 3.19857 4.29363 3.4043L11.8231 10.9338L11.8936 10.8633L11.8231 10.9338C11.87 10.9807 11.9336 11.007 11.9999 11.007C12.0662 11.007 12.1298 10.9807 12.1767 10.9338L12.1061 10.8632L12.1767 10.9338L19.7061 3.4043C19.9119 3.19857 20.2454 3.19857 20.4512 3.4043L20.5955 3.54862C20.8012 3.75435 20.8012 4.0879 20.5955 4.29363L13.066 11.8231L13.1367 11.8938L13.066 11.8231C13.0191 11.87 12.9928 11.9336 12.9928 11.9999C12.9928 12.0662 13.0191 12.1298 13.066 12.1767L20.5955 19.7061C20.8024 19.9131 20.8007 20.2467 20.5951 20.4456C20.5268 20.5116 20.4893 20.5467 20.4677 20.566C20.2266 20.7827 19.893 20.7824 19.6919 20.5812L12.1767 13.066C12.079 12.9684 11.9207 12.9684 11.8231 13.066L4.29364 20.5955C4.08667 20.8024 3.75302 20.8007 3.55421 20.5951C3.48813 20.5268 3.45312 20.4893 3.43376 20.4677C3.21703 20.2266 3.2174 19.893 3.41857 19.6919L10.9338 12.1767C10.9807 12.1298 11.007 12.0662 11.007 11.9999C11.007 11.9336 10.9807 11.87 10.9338 11.8231L10.8631 11.8938L10.9338 11.8231L3.4043 4.29363C3.19857 4.0879 3.19857 3.75435 3.4043 3.54862L3.54862 3.4043Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.72ed7754.svg";
export { ForwardRef as ReactComponent };var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallllery/24px/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M3.54862 3.4043C3.75435 3.19857 4.0879 3.19857 4.29363 3.4043L11.8231 10.9338L11.8936 10.8633L11.8231 10.9338C11.87 10.9807 11.9336 11.007 11.9999 11.007C12.0662 11.007 12.1298 10.9807 12.1767 10.9338L12.1061 10.8632L12.1767 10.9338L19.7061 3.4043C19.9119 3.19857 20.2454 3.19857 20.4512 3.4043L20.5955 3.54862C20.8012 3.75435 20.8012 4.0879 20.5955 4.29363L13.066 11.8231L13.1367 11.8938L13.066 11.8231C13.0191 11.87 12.9928 11.9336 12.9928 11.9999C12.9928 12.0662 13.0191 12.1298 13.066 12.1767L20.5955 19.7061C20.8024 19.9131 20.8007 20.2467 20.5951 20.4456C20.5268 20.5116 20.4893 20.5467 20.4677 20.566C20.2266 20.7827 19.893 20.7824 19.6919 20.5812L12.1767 13.066C12.079 12.9684 11.9207 12.9684 11.8231 13.066L4.29364 20.5955C4.08667 20.8024 3.75302 20.8007 3.55421 20.5951C3.48813 20.5268 3.45312 20.4893 3.43376 20.4677C3.21703 20.2266 3.2174 19.893 3.41857 19.6919L10.9338 12.1767C10.9807 12.1298 11.007 12.0662 11.007 11.9999C11.007 11.9336 10.9807 11.87 10.9338 11.8231L10.8631 11.8938L10.9338 11.8231L3.4043 4.29363C3.19857 4.0879 3.19857 3.75435 3.4043 3.54862L3.54862 3.4043Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.72ed7754.svg";
export { ForwardRef as ReactComponent };